import { css as _css } from "@emotion/core";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import MenuItem from './menu-item';
import MenuSeparator from './menu-separator';
import Submenu from './submenu';
import * as styles from './menu.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var SeparatorMenuItem = '-';
var Menu = _ref => {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'column' : _ref$orientation,
    _ref$indicator = _ref.indicator,
    indicator = _ref$indicator === void 0 ? false : _ref$indicator,
    activeItem = _ref.activeItem,
    labelClass = _ref.labelClass;
  var renderItem = item => {
    if (item === SeparatorMenuItem) {
      return ___EmotionJSX(MenuSeparator, {
        orientation: orientation
      });
    }
    if ('items' in item) {
      return ___EmotionJSX(Submenu, {
        item: item,
        labelClass: labelClass,
        orientation: orientation,
        indicator: indicator,
        activeItem: activeItem
      });
    }
    if ('label' in item) {
      return ___EmotionJSX(MenuItem, _extends({}, item, {
        labelClass: labelClass,
        selected: item.id === activeItem,
        size: orientation === 'row' ? 'compact' : 'full',
        indicator: indicator,
        orientation: orientation
      }));
    }
    return item.component();
  };
  var buildKey = (item, index) => {
    if (item === SeparatorMenuItem) {
      return "separator-".concat(index);
    }
    return item.id;
  };
  return ___EmotionJSX("ul", {
    css: /*#__PURE__*/_css([styles.menu, orientation === 'column' && styles.column, orientation === 'row' && styles.row])
  }, items.map((item, index) => ___EmotionJSX("li", {
    css: /*#__PURE__*/_css([orientation === 'column' && styles.listItemColumn, orientation === 'row' && styles.listItemRow]),
    key: buildKey(item, index)
  }, renderItem(item))));
};
Menu.Item = MenuItem;
Menu.Separator = MenuSeparator;
Menu.Submenu = Submenu;
export default Menu;